var e = function e(_e, t) {
  var l = parseFloat(getComputedStyle(_e).lineHeight),
    i = Math.floor(t / l),
    o = _e;
  o.style.overflow = "hidden", o.style.textOverflow = "ellipsis", o.style.display = "-webkit-box", o.style.webkitLineClamp = "".concat(i || 1), o.style.webkitBoxOrient = "vertical";
};
export { e as default };